import { useReducer } from 'react';

export type ActionType =
  | {
      type: 'REQUEST';
    }
  | {
      type: 'SUCCESS';
      data: {};
    }
  | {
      type: 'FAILURE';
      error: boolean;
    }
  | {
      type: 'PROGRESS';
    };

type QueryState = {
  // TODO: we should export generic type
  data: any | null;
  error: boolean | null;
  loading: boolean;
  progress: number;
};

const initialState = { data: null, error: null, loading: true, progress: 0 };

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * Math.floor(max));
};

const queryReducer = (state: QueryState, action: ActionType) => {
  switch (action.type) {
    case 'REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'PROGRESS':
      return {
        ...state,
        progress: Math.min(state.progress + getRandomInt(25), 100),
      };

    case 'SUCCESS':
      return {
        ...state,
        data: action.data,
        loading: false,
        error: null,
        progress: 100,
      };

    case 'FAILURE':
      return {
        ...state,
        data: null,
        loading: false,
        error: action.error,
        progress: 100,
      };

    default:
      return state;
  }
};

export const useQueryState = (init?: any) => {
  const [state, dispatch] = useReducer(
    queryReducer,
    init ? init : initialState
  );

  return { state, dispatch };
};
